import { render } from "./MetawebBusinessModel.vue?vue&type=template&id=21c91f4a&ts=true"
import script from "./MetawebBusinessModel.vue?vue&type=script&lang=ts"
export * from "./MetawebBusinessModel.vue?vue&type=script&lang=ts"

import "./MetawebBusinessModel.vue?vue&type=style&index=0&id=21c91f4a&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__